export const scrollQuestionnaireTo = (element: HTMLElement) => {
	// Like the privacy view, scroll the document directly in every environment.
	const bottom = element.getBoundingClientRect().bottom + window.scrollY;
	const top = Math.max(0, bottom + 24 - window.innerHeight);
	if (top <= window.scrollY) return;
	window.scrollTo({ top, behavior: 'smooth' });
};
